var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0837 5.83341V12.5001H5.29199C3.98366 12.5001 2.91699 13.5667 2.91699 14.8751V5.83341C2.91699 2.50008 3.75033 1.66675 7.08366 1.66675H12.917C16.2503 1.66675 17.0837 2.50008 17.0837 5.83341Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0837 12.5V15.4167C17.0837 17.025 15.7753 18.3333 14.167 18.3333H5.83366C4.22533 18.3333 2.91699 17.025 2.91699 15.4167V14.875C2.91699 13.5667 3.98366 12.5 5.29199 12.5H17.0837Z",
    fill: "#838B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 6.45825H6.66699C6.32533 6.45825 6.04199 6.17492 6.04199 5.83325C6.04199 5.49159 6.32533 5.20825 6.66699 5.20825H13.3337C13.6753 5.20825 13.9587 5.49159 13.9587 5.83325C13.9587 6.17492 13.6753 6.45825 13.3337 6.45825Z",
    fill: "#838B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 9.375H6.66699C6.32533 9.375 6.04199 9.09167 6.04199 8.75C6.04199 8.40833 6.32533 8.125 6.66699 8.125H10.8337C11.1753 8.125 11.4587 8.40833 11.4587 8.75C11.4587 9.09167 11.1753 9.375 10.8337 9.375Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.defad67c5ffc99204b9ba1532e7e61c8.svg";
export { ForwardRef as ReactComponent };